import React, { useRef, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import styled from '@emotion/styled';
import NavBar from '../components/navbar/NavBar';
import SideBar from '../components/sidebar/SideBar';
import { useWindowWide } from '../utils/common_functions';
import colors from '../theme/colors';
import { ConfigProvider } from 'antd';
import { fontFamilys } from '../theme/common_style';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const MainContainer = styled.div({
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  background: colors.gray90
});

const theme = {
  token: {
    fontFamily: fontFamilys.poppinsFont
  }
};

function Layout() {
  const largeScreen = useWindowWide(750);
  const isSidebarOpen = useSelector((state) => state?.sidebar?.isSidebarOpen);
  const itemWrapperRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (itemWrapperRef.current) {
      itemWrapperRef.current.scrollTop = 0;
    }
  }, [location.pathname]);

  return (
    <ConfigProvider theme={theme}>
      <MainContainer>
        <NavBar />
        <div style={{ display: 'flex', flex: 1 }}>
          {largeScreen && <SideBar />}
          <ItemWrapper
            ref={itemWrapperRef}
            marginspace={largeScreen ? (isSidebarOpen ? '250px' : '80px') : '0px'}>
            <Outlet />
          </ItemWrapper>
        </div>
      </MainContainer>
    </ConfigProvider>
  );
}

export default Layout;

const ItemWrapper = styled.div(({ marginspace }) => ({
  flex: 1,
  background: colors.gray90,
  padding: '0 24px 24px',
  marginTop: '12px',
  height: 'calc(100vh - 87px)',
  overflow: 'auto',
  marginLeft: marginspace, // '250px',
  '::-webkit-scrollbar': {
    display: 'none'
  }
}));
